export enum NotificationsTypes {
  'LOAD_NOTIFICATIONS_REQUEST' = '@notifications/LOAD_NOTIFICATIONS_REQUEST',
  'LOAD_NOTIFICATIONS_SUCCESS' = '@notifications/LOAD_NOTIFICATIONS_SUCCESS',
  'LOAD_NOTIFICATIONS_FAILURE' = '@notifications/LOAD_NOTIFICATIONS_FAILURE',

  'LOAD_MESSAGE_READ' = '@notifications/LOAD_MESSAGE_READ',
}

export interface NotificationsState {
  readonly notification: number;
  readonly loading: boolean;
  readonly error: boolean;
}
